import React, {useContext} from 'react'

export type DockComponent<T> = React.ComponentType<T>
export type DockProps<T> = T
export type Dock<T = any> = {component: DockComponent<T>; props: DockProps<T>}

export type DocksStateContextProps = {
  dock: Dock | null
}

export type DocksActionsContextProps = {
  open: <T>(component: DockComponent<T>, props: DockProps<T>) => void
  close: () => void
}

export const DocksActionsContext = React.createContext<DocksActionsContextProps>(null as any)
export const DocksStateContext = React.createContext<DocksStateContextProps>(null as any)

export function useDocksStateContext() {
  return useContext(DocksStateContext)
}

export function useDocksActionsontext() {
  return useContext(DocksActionsContext)
}
